/**
 * Calculate the strength of a password and provide feedback based on various criteria.
 *
 * @param {string} password - The password to evaluate for strength.
 * @returns {{ percentage: string, color: string }} An object containing the percentage strength and color representation.
 */
export const calculatePasswordStrength = (password: string) => {
  const colors = [
    '#ffffff',
    '#da1212',
    '#e6a000',
    '#7d8701',
    '#018701',
    '#222eed',
  ];
  const max = 5;
  let strength = 0;

  // Add points for each type of character.
  if (/[a-z]/.test(password)) strength++; // Lowercase chars.
  if (/[A-Z]/.test(password)) strength++; // Uppercase chars.
  if (/[0-9]/.test(password)) strength++; // Number chars.
  if (/[^a-zA-Z0-9]/.test(password)) strength++; // Symbol chars.

  // Add points for length.
  if (password.length >= 10) strength++;
  if (password.length >= 15) strength++;
  if (password.length >= 20) strength++;

  // Cap the strength value to a maximum.
  const finalValue = Math.min(strength, max);

  // Calculate percentage.
  const percentage = `${(finalValue / max) * 100}%`;

  return {
    percentage,
    color: colors[finalValue] || colors[colors.length - 1],
  };
};
